import { PostEditorReducerFunction, PostEditorTitleUpdateAction } from '../PostEditorActions';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';

export const titleUpdateReducer: PostEditorReducerFunction<PostEditorTitleUpdateAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, customizeIndex, title } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      content: {
        title: {
          $set: title
        }
      }
    });

  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'content', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'profileRequired',
    'titleCharLimit'
  ]);
};
